var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleXmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "#4D4F5C",
  strokeWidth: 2,
  viewBox: "0 0 42 42"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 20,
  stroke: "#D5D4DE"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M26 16 16 26M16 16l10 10"
})));
export { SvgCircleXmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiM0RDRGNUMiIHN0cm9rZS13aWR0aD0iMiIgPgo8Y2lyY2xlIGN4PSIyMSIgY3k9IjIxIiByPSIyMCIgc3Ryb2tlPSIjRDVENERFIi8+CjxwYXRoIGQ9Ik0yNiAxNkwxNiAyNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNiAxNkwyNiAyNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";